<button class="drawer-activator" (click)="drawer_visible = !drawer_visible"
  nz-tooltip nzTooltipTitle="Open image flipper" nzTooltipPlacement="left">
  <nz-badge [nzCount]="images.length" nzSize="small">
    <span nz-icon nzType="picture" nzTheme="outline" class="activator-icon"></span>
  </nz-badge>
</button>

<nz-drawer [nzWidth]="drawer_width" [nzVisible]="drawer_visible" nzTitle="Image flipper"
  (nzOnClose)="drawer_visible = false">
  <ng-container *nzDrawerContent>
    @if (images.length == 0) {
      <div class="flipper-empty">
        <nz-empty nzNotFoundContent="No images have been added to the flipper yet"></nz-empty>
        <p class="empty-hint">
          Pin slice or shot images from the chat using the
          <span nz-icon nzType="select" nzTheme="outline"></span>
          button in their top-right corner, then flip through them here to compare iterations.
        </p>
      </div>
    }

    @if (images.length > 0) {
      <!-- Toolbar -->
      <div class="flipper-toolbar">
        <div class="playback-controls">
          <button class="ctrl-btn" (click)="prev()" nz-tooltip nzTooltipTitle="Previous (←)">
            <span nz-icon nzType="left" nzTheme="outline"></span>
          </button>
          <button class="ctrl-btn ctrl-btn--play" (click)="togglePlayback()" [disabled]="images.length < 2"
            nz-tooltip [nzTooltipTitle]="is_playing ? 'Pause' : 'Auto-flip'">
            <span nz-icon [nzType]="is_playing ? 'pause' : 'caret-right'" nzTheme="outline"></span>
          </button>
          <button class="ctrl-btn" (click)="next()" nz-tooltip nzTooltipTitle="Next (→)">
            <span nz-icon nzType="right" nzTheme="outline"></span>
          </button>
          <span class="frame-indicator">{{ current_index + 1 }} / {{ images.length }}</span>
        </div>

        <div class="toolbar-right">
          <button class="ctrl-btn" [class.ctrl-btn--active]="fill_image" (click)="fill_image = !fill_image"
            nz-tooltip [nzTooltipTitle]="fill_image ? 'Fit image (preserve aspect ratio)' : 'Stretch to fill space'">
            <span nz-icon [nzType]="fill_image ? 'compress' : 'expand'" nzTheme="outline"></span>
          </button>
          <nz-select class="speed-select" [(ngModel)]="flip_interval_ms" (ngModelChange)="onSpeedChange()"
            nzSize="small">
            @for (opt of speed_options; track opt.value) {
              <nz-option [nzValue]="opt.value" [nzLabel]="opt.label"></nz-option>
            }
          </nz-select>
          <button class="ctrl-btn ctrl-btn--danger" nz-popconfirm
            nzPopconfirmTitle="Remove all images from the flipper?" nzOkText="Clear" [nzOkDanger]="true"
            (nzOnConfirm)="clear_all()" nz-tooltip nzTooltipTitle="Clear all">
            <span nz-icon nzType="delete" nzTheme="outline"></span>
          </button>
        </div>
      </div>

      <!-- Stage -->
      <div class="stage">
        @if (currentImage) {
          <div class="stage-meta">
            <div class="stage-job-name">{{ currentImage.image_information.job_name }}</div>
            <div class="stage-details">
              Iteration:
              {{ currentImage.image_information.iteration }}
              {{
              currentImage.image_information.dimension &&
              " | " + currentImage.image_information.dimension
              }}
              {{
              currentImage.image_information.slice_number &&
              "(" + currentImage.image_information.slice_number + ")"
              }}
            </div>
          </div>
        }
        <div class="stage-image-wrap">
          <!-- all frames stay mounted so flipping is instant -->
          @for (image of images; track image; let i = $index) {
            <img [src]="image.image_link" class="stage-img" [class.visible]="i === current_index"
              [class.fill]="fill_image" />
          }
        </div>
      </div>

      <!-- Thumbnails -->
      <div class="thumb-strip">
        @for (image of images; track image; let i = $index) {
          <div class="thumb" [class.active]="i === current_index">
            <img [src]="image.image_link" class="thumb-img" (click)="go_to_image(i)"
              nz-tooltip [nzTooltipTitle]="image.image_information.job_name + ' — iter ' + image.image_information.iteration" />
            <button nz-button nzSize="small" nzShape="circle" nzType="text" nzDanger class="image-remove-button"
              (click)="remove_image(i)">
              <span nz-icon nzType="close" nzTheme="outline"></span>
            </button>
          </div>
        }
      </div>
    }
  </ng-container>
</nz-drawer>
